module.exports = __webpack_public_path__ + "static/zoom-053a5f41661b0c323d82c8226eac056b.gif";